import PendingActionDetails from "../components/PendingActionDetails";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { BiSolidDownArrow, BiSolidRightArrow } from "react-icons/bi";
import { FiEdit, FiTrash } from "react-icons/fi";
import config from './../config';
import Toast from "../components/Common/Toast";

const PendingActions = () => {
  const companyId = useSelector((state) => state.user.companyId);
  const role = useSelector((state) => state.user.role);
  const email1 = useSelector((state) => state.user.email);
  const isAdminUser = Number(role) === 1;
  const navigate = useNavigate();
  const [baskets, setBaskets] = useState([])
  const [err, setErr] = useState("");
  const [messageType, setMessageType] = useState("");
  const [toast, setToast] = useState({ show: false, message: "", type: "info" });
  const [loading, setLoading] = useState(false);
  const [editingClientOrderId, setEditingClientOrderId] = useState(null);
  const [editingQuantity, setEditingQuantity] = useState("");
  const [rowLoading, setRowLoading] = useState({});
  const [openAccordionState, setOpenAccordionState] = useState({});
  const [openDetailsByKey, setOpenDetailsByKey] = useState({});
  const [openSectionLoading, setOpenSectionLoading] = useState({});
  const [lastOpenedKey, setLastOpenedKey] = useState(null);
  const [deleteDialog, setDeleteDialog] = useState({ open: false, clientOrderId: null, groupKey: null, basketId: null });
  const [isMobileView, setIsMobileView] = useState(() => window.innerWidth < 768);
  const confirmDeleteButtonRef = useRef(null);
  const accordionSectionRefs = useRef({});
  /* useEffect(() => {
    if (email1 === null || email1 === "") {
      navigate("/")
    }
  }) */
  useEffect(() => {
    getPendingActions(true)
  }, [])

  useEffect(() => {
    let interval;
    const hasErrorCount = baskets.some(basket =>
      (basket.status === 'inserted' || basket.status === 'success') && basket.errorCount > 0
    );
    if (hasErrorCount) {
      interval = setInterval(() => {
        getPendingActions(false);
      }, 20000); // 20 seconds
    }
    return () => clearInterval(interval);
  }, [baskets]);

  const getPendingActions = async (showLoader = false) => {

    if (showLoader) {
      setLoading(true);
    }

    try {

      const res = await axios.get(`${config.BL_API_URL}/transaction/v1/getTransactionErrors/${ companyId }`);
      //console.log(res)

      if (res.data)
        setBaskets(res.data)
      else
        setErr("backend error")

    } catch (err) {
      //console.log("error 333 ", err)
      //if (err.response.status === 500)
      setErr("Server error...");
      //else
      //    setErr(err.response.data);
      if (err?.response?.data) setErr(err.response.data);
    } finally {
      if (showLoader) {
        setLoading(false);
      }
    }
  }

  const isOpenStatus = (status) => status === null || status === undefined || String(status).trim() === "";

  const getErrorMessage = (error, fallbackMessage) => {
    const errorMessage = error?.response?.data?.messages;
    if (Array.isArray(errorMessage) && errorMessage.length > 0) {
      return errorMessage.join(", ");
    }
    if (typeof errorMessage === "string" && errorMessage.trim() !== "") {
      return errorMessage;
    }
    if (typeof error?.response?.data === "string" && error.response.data.trim() !== "") {
      return error.response.data;
    }
    return fallbackMessage;
  };

  const showToast = (message, type) => {
    setToast({ show: true, message, type });
  };

  const handleEditClick = (clientOrderId, quantity) => {
    if (!isAdminUser) return;
    setEditingClientOrderId(clientOrderId);
    setEditingQuantity(String(quantity ?? ""));
  };

  const handleCancelEdit = () => {
    setEditingClientOrderId(null);
    setEditingQuantity("");
  };

  const handleQuantityKeyDown = (event, clientOrderId, groupKey, basketId, isBusy) => {
    if (isBusy) return;

    if (event.key === "Enter") {
      event.preventDefault();
      handleSaveEdit(clientOrderId, groupKey, basketId);
      return;
    }

    if (event.key === "Escape") {
      event.preventDefault();
      handleCancelEdit();
    }
  };

  const closeDeleteDialog = () => {
    setDeleteDialog({ open: false, clientOrderId: null, groupKey: null, basketId: null });
  };

  const executeDelete = async (clientOrderId, groupKey, basketId) => {
    if (!clientOrderId) return;

    setRowLoading((prev) => ({ ...prev, [clientOrderId]: true }));
    try {
      const response = await axios.delete(`${config.BL_API_URL}/clientOrder/v1/deleteClientOrder/${clientOrderId}`);
      if (response?.data?.status === "Success") {
        showToast("Order deleted successfully.", "success");
        await getPendingActions(false);
        if (groupKey && basketId) {
          await fetchOpenDetails(groupKey, basketId);
        }
      } else {
        showToast(response?.data?.messages || "Failed to delete order.", "error");
      }
    } catch (error) {
      showToast(getErrorMessage(error, "Failed to delete order."), "error");
    } finally {
      setRowLoading((prev) => {
        const next = { ...prev };
        delete next[clientOrderId];
        return next;
      });
    }
  };

  const handleDelete = (clientOrderId, groupKey, basketId) => {
    if (!isAdminUser) return;
    if (!clientOrderId) return;
    setDeleteDialog({ open: true, clientOrderId, groupKey, basketId });
  };

  const handleConfirmDelete = async () => {
    const { clientOrderId, groupKey, basketId } = deleteDialog;
    closeDeleteDialog();
    await executeDelete(clientOrderId, groupKey, basketId);
  };

  const handleSaveEdit = async (clientOrderId, groupKey, basketId) => {
    if (!isAdminUser) return;
    const parsedQuantity = Number(editingQuantity);
    if (!Number.isFinite(parsedQuantity) || parsedQuantity <= 0) {
      showToast("Please enter a valid quantity greater than zero.", "warning");
      return;
    }

    setRowLoading((prev) => ({ ...prev, [clientOrderId]: true }));
    try {
      const response = await axios.post(`${config.BL_API_URL}/clientOrder/v1/updateClientOrder`, [clientOrderId, parsedQuantity]);
      if (response?.data?.status === "Success") {
        showToast("Quantity updated successfully.", "success");
        handleCancelEdit();
        await getPendingActions(false);
        if (groupKey && basketId) {
          await fetchOpenDetails(groupKey, basketId);
        }
      } else {
        showToast(response?.data?.messages || "Failed to update quantity.", "error");
      }
    } catch (error) {
      showToast(getErrorMessage(error, "Failed to update quantity."), "error");
    } finally {
      setRowLoading((prev) => {
        const next = { ...prev };
        delete next[clientOrderId];
        return next;
      });
    }
  };

  const normalizeKey = (key) => String(key || "").replace(/[^a-zA-Z0-9]/g, "").toLowerCase();

  const getValueFromAliasesDeep = (obj, aliases) => {
    if (!obj || typeof obj !== "object") return "";

    const targetKeys = aliases.map((alias) => normalizeKey(alias));
    const queue = [obj];
    const seen = new Set();

    while (queue.length > 0) {
      const current = queue.shift();
      if (!current || typeof current !== "object") continue;
      if (seen.has(current)) continue;
      seen.add(current);

      for (const [key, value] of Object.entries(current)) {
        const normalizedCurrentKey = normalizeKey(key);
        if (
          targetKeys.includes(normalizedCurrentKey) &&
          value !== undefined &&
          value !== null &&
          String(value).trim() !== ""
        ) {
          return value;
        }
      }

      for (const value of Object.values(current)) {
        if (Array.isArray(value)) {
          for (const item of value) {
            if (item && typeof item === "object") {
              queue.push(item);
            }
          }
        } else if (value && typeof value === "object") {
          queue.push(value);
        }
      }
    }

    return "";
  };

  const normalizeOpenRow = (row) => {
    const clientOrderId = getValueFromAliasesDeep(row, ["clientOrderId", "clientorderId", "client_order_id", "clientOrderID"]);
    return {
      ...row,
      clientOrderId,
      clientCode: getValueFromAliasesDeep(row, ["clientCode", "clientcode", "client_code", "client", "clientId"]),
      basketName: getValueFromAliasesDeep(row, ["basketName", "basketname", "basket_name"]),
      scripName: getValueFromAliasesDeep(row, ["scripName", "scriptName", "scripname", "scriptname", "scrip_name", "script_name", "symbol", "stockName"]),
      orderType: getValueFromAliasesDeep(row, ["orderType", "ordertype", "order_type", "side", "tradeType"]),
      quantity: getValueFromAliasesDeep(row, ["quantity", "qty", "orderQty", "orderQuantity", "order_qty"])
    };
  };

  const getUniqueClientCount = (rows = []) => {
    const clients = new Set(
      rows
        .map((row) => String(row?.clientCode || "").trim())
        .filter((clientCode) => clientCode !== "")
    );
    return clients.size;
  };

  const getSummaryClientCount = (row) => {
    const clientCountAliases = [
      "uniqueClientCount",
      "clientCount",
      "totalClients",
      "totalClient",
      "totalClientCount"
    ];

    for (const alias of clientCountAliases) {
      const value = Number(getValueFromAliasesDeep(row, [alias]));
      if (Number.isFinite(value) && value >= 0) {
        return value;
      }
    }

    const clientCode = String(getValueFromAliasesDeep(row, ["clientCode", "clientcode", "client_code"]) || "").trim();
    if (clientCode !== "") {
      return 1;
    }

    return null;
  };

  const openBaskets = baskets.filter((item) => isOpenStatus(item.status));
  const normalizedOpenBaskets = openBaskets.map((item) => normalizeOpenRow(item));
  const groupedOpenBaskets = normalizedOpenBaskets.reduce((groups, item) => {
    const basketName = item.basketName || "Open Orders";
    const groupKey = `${item.basketId || "no-basket"}::${basketName}`;
    if (!groups[groupKey]) {
      groups[groupKey] = {
        basketId: item.basketId,
        basketName,
        rows: [],
        totalOpenCount: 0,
        totalClientCount: 0,
        hasSummaryClientCount: false
      };
    }
    groups[groupKey].rows.push(item);

    const parsedErrorCount = Number(item.errorCount);
    groups[groupKey].totalOpenCount += Number.isFinite(parsedErrorCount) && parsedErrorCount >= 0
      ? parsedErrorCount
      : 1;

    const parsedClientCount = getSummaryClientCount(item);
    if (parsedClientCount !== null) {
      groups[groupKey].totalClientCount += parsedClientCount;
      groups[groupKey].hasSummaryClientCount = true;
    }

    return groups;
  }, {});
  const openKeys = Object.keys(groupedOpenBaskets);
  const nonOpenBaskets = baskets.filter((item) => !isOpenStatus(item.status));

  const fetchOpenDetails = async (groupKey, basketId) => {
    if (!basketId) return;

    setOpenSectionLoading((prev) => ({ ...prev, [groupKey]: true }));
    try {
      const response = await axios.get(`${config.BL_API_URL}/transaction/v1/getTranscationErrorDetails`, {
        params: { basketId, status: "open" }
      });

      const apiRows = Array.isArray(response?.data)
        ? response.data.map((item) => normalizeOpenRow(item))
        : [];

      setOpenDetailsByKey((prev) => ({ ...prev, [groupKey]: apiRows }));
    } catch (error) {
      showToast(getErrorMessage(error, "Failed to load open order details."), "error");
    } finally {
      setOpenSectionLoading((prev) => {
        const next = { ...prev };
        delete next[groupKey];
        return next;
      });
    }
  };

  const handleOpenAccordionToggle = async (groupKey, basketId) => {
    const isCurrentlyOpen = !!openAccordionState[groupKey];
    if (isCurrentlyOpen) {
      setOpenAccordionState((prev) => ({ ...prev, [groupKey]: false }));
      return;
    }

    setOpenAccordionState((prev) => ({ ...prev, [groupKey]: true }));
    setLastOpenedKey(groupKey);
    await fetchOpenDetails(groupKey, basketId);
  };

  useEffect(() => {
    if (!isMobileView || !lastOpenedKey || !openAccordionState[lastOpenedKey]) return;

    const sectionNode = accordionSectionRefs.current[lastOpenedKey];
    if (!sectionNode) return;

    const scrollWithOffset = () => {
      const top = window.scrollY + sectionNode.getBoundingClientRect().top - 88;
      window.scrollTo({
        top: Math.max(0, top),
        behavior: "smooth"
      });
    };

    // Keep the expanded accordion header visible on mobile after expand animation and data load.
    const immediateTimer = window.setTimeout(scrollWithOffset, 0);
    const delayedTimer = window.setTimeout(scrollWithOffset, 360);

    return () => {
      window.clearTimeout(immediateTimer);
      window.clearTimeout(delayedTimer);
    };
  }, [isMobileView, lastOpenedKey, openAccordionState, openDetailsByKey]);

  useEffect(() => {
    if (!deleteDialog.open) return;

    const handleDialogKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        handleConfirmDelete();
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closeDeleteDialog();
      }
    };

    window.addEventListener("keydown", handleDialogKeyDown);
    return () => window.removeEventListener("keydown", handleDialogKeyDown);
  }, [deleteDialog]);

  useEffect(() => {
    if (deleteDialog.open) {
      confirmDeleteButtonRef.current?.focus();
    }
  }, [deleteDialog.open]);

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const groupedBaskets = nonOpenBaskets.reduce((groups, item) => {
    const status = item.status ? item.status : 'open';
    const key = `${item.basketId}-${status}`;
    if (!groups[key]) {
      groups[key] = {
        rows: [],
        totalClientCount: 0,
        hasSummaryClientCount: false,
        totalStatusCount: 0
      };
    }
    groups[key].rows.push(item);

    const parsedErrorCount = Number(item.errorCount);
    groups[key].totalStatusCount += Number.isFinite(parsedErrorCount) && parsedErrorCount >= 0 ? parsedErrorCount : 1;

    const parsedClientCount = getSummaryClientCount(item);
    if (parsedClientCount !== null) {
      groups[key].totalClientCount += parsedClientCount;
      groups[key].hasSummaryClientCount = true;
    }

    return groups;
  }, {});
  const keys = Object.keys(groupedBaskets);

  return (
    <div className=" my-14 md:px-14 max-w-screen-2xl mx-auto py-5">
      {deleteDialog.open && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4">
          <div className="w-full max-w-md rounded-lg bg-white p-5 shadow-lg">
            <h3 className="text-lg font-semibold text-gray-800">Confirm Delete</h3>
            <p className="mt-2 text-sm text-gray-600">Are you sure you want to delete this order?</p>
            <div className="mt-5 flex items-center justify-end gap-3">
              <button
                type="button"
                onClick={closeDeleteDialog}
                className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-red-400 hover:text-red-600"
              >
                Cancel
              </button>
              <button
                ref={confirmDeleteButtonRef}
                type="button"
                onClick={handleConfirmDelete}
                className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ show: false, message: "", type: "info" })}
      />
      {loading && baskets.length === 0 && (
        <div className="py-8 px-3 flex justify-center items-center text-gray-600">
          <div className="flex items-center gap-3">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span>Loading pending actions...</span>
          </div>
        </div>
      )}
      {/*       <div className="py-1 px-1 flex justify-center items-center">
        <select>
          <option value="0">None</option>
          <option value="1">Orders Rejected</option>
          <option value="2">Order Generated But no yet sent for execution</option>
        </select>
      </div> */}
      {/* <div className="mx-24">
        {baskets.map((basket) => (
          <PendingActionDetails basketId={basket.basketId} keyName={basket.basketName} basket={basket} status={basket.status} />
        ))}
      </div>       */}
      {/* {err} */}
      {openKeys.length > 0 && (
        openKeys.map((openKey) => {
          const group = groupedOpenBaskets[openKey] || { basketId: null, basketName: "Open Orders", rows: [], totalOpenCount: 0, totalClientCount: 0, hasSummaryClientCount: false };
          const isOpen = !!openAccordionState[openKey];
          const hasDetailRows = Array.isArray(openDetailsByKey[openKey]);
          const rows = hasDetailRows ? openDetailsByKey[openKey] : group.rows;
          const displayOpenCount = hasDetailRows ? rows.length : group.totalOpenCount;
          const uniqueClientCount = hasDetailRows
            ? getUniqueClientCount(rows)
            : (group.hasSummaryClientCount ? group.totalClientCount : group.totalOpenCount);
          const sectionLoading = !!openSectionLoading[openKey];

          return (
        <div
          className="py-1 mb-1"
          key={`open-${openKey}`}
          ref={(el) => {
            if (el) {
              accordionSectionRefs.current[openKey] = el;
            }
          }}
        >
          <button
            type="button"
            onClick={() => handleOpenAccordionToggle(openKey, group.basketId)}
            className={`p-2 flex justify-between items-center w-full text-center bg-btnSecondary text-white rounded-lg ${isOpen ? 'sticky top-0 z-20' : ''}`}
          >
            <span className="w-full text-center">{group.basketName} total open {displayOpenCount} | total clients {uniqueClientCount}</span>
            {isOpen ? <BiSolidDownArrow className="text-yellow-300" /> : <BiSolidRightArrow className="text-yellow-200" />}
          </button>
          <div className={`mx-2 grid overflow-hidden transition-all duration-300 ease-in-out text-slate-600 text-sm ${isOpen ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
            <div className="overflow-hidden">
              {sectionLoading && (
                <div className="px-3 py-2 text-sm text-gray-600">Loading open details...</div>
              )}
              <div className="flex flex-col">
                <div className="-m-1.5 overflow-x-auto">
                  <div className="p-1.5 min-w-full inline-block align-middle">
                    <div className="border rounded-lg divide-y divide-gray-200">
                      {!isMobileView && <div className="max-h-[26rem] overflow-y-auto overflow-x-auto">
                        <table className="min-w-full divide-y divide-gray-400 text-sm">
                          <thead className="sticky top-0 z-10 bg-gray-200 text-gray-700">
                            <tr>
                              <th className="px-3 py-2 text-start font-medium border">Client Code</th>
                              <th className="px-3 py-2 text-start font-medium border">Basket Name</th>
                              <th className="px-3 py-2 text-start font-medium border">Scrip Name</th>
                              <th className="px-3 py-2 text-start font-medium border">Order Type</th>
                              <th className="px-3 py-2 text-start font-medium border">Quantity</th>
                              <th className="px-3 py-2 text-start font-medium border">Action</th>
                            </tr>
                          </thead>
                          <tbody className="divide-y divide-gray-200">
                {rows.map((row, index) => {
                  const rowKey = row.clientOrderId || `${row.basketName || "open"}-${index}`;
                  const isEditing = editingClientOrderId === row.clientOrderId;
                  const isBusy = !!rowLoading[row.clientOrderId];
                  const hasClientOrderId = row.clientOrderId !== null && row.clientOrderId !== undefined && String(row.clientOrderId).trim() !== "";

                  return (
                    <tr key={rowKey} className={index % 2 === 0 ? '' : 'bg-gray-100'}>
                      <td className="px-3 py-2 text-gray-800 border">{row.clientCode || "-"}</td>
                      <td className="px-3 py-2 text-gray-800 border">{row.basketName || "-"}</td>
                      <td className="px-3 py-2 text-gray-800 border">{row.scripName || "-"}</td>
                      <td className="px-3 py-2 text-gray-800 border">{row.orderType || "-"}</td>
                      <td className="px-3 py-2 text-gray-800 border">
                        {isEditing ? (
                          <input
                            type="number"
                            min="1"
                            value={editingQuantity}
                            onChange={(e) => setEditingQuantity(e.target.value)}
                            onKeyDown={(event) => handleQuantityKeyDown(event, row.clientOrderId, openKey, group.basketId, isBusy)}
                            className="border border-gray-300 rounded px-2 py-1 w-24 text-gray-800"
                          />
                        ) : (row.quantity || row.quantity === 0 ? row.quantity : "-")}
                      </td>
                      <td className="px-3 py-2 text-gray-800 border">
                        {hasClientOrderId && isAdminUser ? (
                          <div className="flex items-center gap-2 flex-wrap">
                            {isEditing ? (
                              <>
                                <button
                                  type="button"
                                  onClick={() => handleSaveEdit(row.clientOrderId, openKey, group.basketId)}
                                  disabled={isBusy}
                                  className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600 disabled:opacity-50 disabled:pointer-events-none"
                                >
                                  {isBusy ? "Saving..." : "Save"}
                                </button>
                                <button
                                  type="button"
                                  onClick={handleCancelEdit}
                                  disabled={isBusy}
                                  className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-red-400 hover:text-red-600 disabled:opacity-50 disabled:pointer-events-none"
                                >
                                  Cancel
                                </button>
                              </>
                            ) : (
                              <>
                                <button
                                  type="button"
                                  onClick={() => handleEditClick(row.clientOrderId, row.quantity)}
                                  disabled={isBusy}
                                  className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600 disabled:opacity-50 disabled:pointer-events-none"
                                >
                                  <FiEdit className="text-base" />Edit
                                </button>
                                <button
                                  type="button"
                                  onClick={() => handleDelete(row.clientOrderId, openKey, group.basketId)}
                                  disabled={isBusy}
                                  className="inline-flex items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent text-blue-400 hover:text-blue-600 disabled:opacity-50 disabled:pointer-events-none"
                                >
                                  <FiTrash className="text-base" />{isBusy ? "Deleting..." : "Delete"}
                                </button>
                              </>
                            )}
                          </div>
                        ) : (
                          <span className="text-gray-400">-</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
                          </tbody>
                        </table>
                      </div>}

                      {isMobileView && (
                        <div className="space-y-2 p-2">
                          {rows.map((row, index) => {
                            const rowKey = row.clientOrderId || `${row.basketName || "open"}-${index}`;
                            const isEditing = editingClientOrderId === row.clientOrderId;
                            const isBusy = !!rowLoading[row.clientOrderId];
                            const hasClientOrderId = row.clientOrderId !== null && row.clientOrderId !== undefined && String(row.clientOrderId).trim() !== "";

                            return (
                              <div key={rowKey} className="rounded-md border border-gray-200 bg-white p-3">
                                <div className="grid grid-cols-1 gap-1.5 text-sm">
                                  <div><span className="text-xs uppercase text-gray-500">Client Code</span><p className="text-gray-800">{row.clientCode || "-"}</p></div>
                                  <div><span className="text-xs uppercase text-gray-500">Basket</span><p className="text-gray-800">{row.basketName || "-"}</p></div>
                                  <div><span className="text-xs uppercase text-gray-500">Scrip</span><p className="text-gray-800 break-words">{row.scripName || "-"}</p></div>
                                  <div><span className="text-xs uppercase text-gray-500">Order Type</span><p className="text-gray-800">{row.orderType || "-"}</p></div>
                                  <div>
                                    <span className="text-xs uppercase text-gray-500">Quantity</span>
                                    {isEditing ? (
                                      <input
                                        type="number"
                                        min="1"
                                        value={editingQuantity}
                                        onChange={(e) => setEditingQuantity(e.target.value)}
                                        onKeyDown={(event) => handleQuantityKeyDown(event, row.clientOrderId, openKey, group.basketId, isBusy)}
                                        className="mt-1 border border-gray-300 rounded px-2 py-1 w-full text-gray-800"
                                      />
                                    ) : (
                                      <p className="text-gray-800">{row.quantity || row.quantity === 0 ? row.quantity : "-"}</p>
                                    )}
                                  </div>
                                </div>
                                <div className="mt-2 pt-2 border-t border-gray-100">
                                  {hasClientOrderId && isAdminUser ? (
                                    <div className="flex items-center gap-2 flex-wrap justify-end">
                                      {isEditing ? (
                                        <>
                                          <button type="button" onClick={() => handleSaveEdit(row.clientOrderId, openKey, group.basketId)} disabled={isBusy} className="text-sm text-blue-600 disabled:opacity-50">{isBusy ? "Saving..." : "Save"}</button>
                                          <button type="button" onClick={handleCancelEdit} disabled={isBusy} className="text-sm text-red-600 disabled:opacity-50">Cancel</button>
                                        </>
                                      ) : (
                                        <>
                                          <button type="button" onClick={() => handleEditClick(row.clientOrderId, row.quantity)} disabled={isBusy} className="inline-flex items-center gap-1 text-sm text-blue-600 disabled:opacity-50"><FiEdit className="text-base" />Edit</button>
                                          <button type="button" onClick={() => handleDelete(row.clientOrderId, openKey, group.basketId)} disabled={isBusy} className="inline-flex items-center gap-1 text-sm text-red-600 disabled:opacity-50"><FiTrash className="text-base" />{isBusy ? "Deleting..." : "Delete"}</button>
                                        </>
                                      )}
                                    </div>
                                  ) : (
                                    <span className="text-gray-400">-</span>
                                  )}
                                </div>
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
          );
        })
      )}

      {keys.length > 0 ? (
        keys.map((key) => {
          const group = groupedBaskets[key];
          const uniqueClientCount = group.hasSummaryClientCount ? group.totalClientCount : group.totalStatusCount;

          return (
          <div key={key}>

            {group.rows.map((basket) => (
              <PendingActionDetails key={`${basket.basketId}-${basket.scripName}-${basket.clientOrderId || "na"}`} basketId={basket.basketId} keyName={basket.basketName} basket={basket} status={key.substring(key.indexOf('-') + 1)} uniqueClientCount={uniqueClientCount} />
            ))}
          </div>
        )})
      ) : (
        !loading && openBaskets.length === 0 && (
          <div className="py-1 px-1 flex justify-center items-center">
            <span className="mb-6 ml-4 text-lg ">No records</span>
          </div>
        )
      )}

    </div>
  )
}

export default PendingActions